import type { App } from 'vue'
import { inject } from 'vue'

const key = 'app.plugin.AppleAppId'

type IdType = string | undefined

export function provideAppleAppId(app: App, id: IdType): void {
    app.provide(key, id)
}

export function useAppleAppId(): IdType {
    return inject(key) as IdType
}
